import React, { useState, useEffect } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Table, Icon, Modal } from 'antd';
import DrawerOutros from "./Drawer/DrawerOutros";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
import axios from "axios";

const confirm = Modal.confirm;

const Tabela = ({ match }) => {
    const [outroId, setOutroId] = useState();
    const [outros, setOutros] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visible, setVisible] = useState(false)
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const extensions = [".bmp", ".csv", ".odt", ".doc", ".docx", ".gif", ".htm", ".html", ".jpg", ".jpeg", ".pdf", ".png", ".ppt", ".pptx", ".tiff", ".txt", ".xls", ".xlsx"];

    const cols = [
        {
            title: "Data",
            dataIndex: "data"
        },
        {
            title: "Tipo",
            dataIndex: "tipo"
        },
        {
            title: "Descrição",
            dataIndex: "descricao"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 50
        }
    ];

    const carregar = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-outros-utilizador",
            params: {
                code: match.params.code
            }
        })
            .then(response => {
                const lista = response.data.map(item => {
                    return {
                        key: item.id,
                        data: item.data,
                        tipo: item.titulo,
                        descricao: item.descricao,
                        opcoes: <div className="documentos-opcoes">
                            <Link to="#" title="Visualizar" className="botao-icon-detalhe" onClick={() => { setModalVisible(true); setDocs(item.ficheiros) }}>
                                <Icon type="eye" />
                            </Link>
                            <Link className="botao-icon-editar" to="#" title="Editar" onClick={() => { setOutroId(item.id); setVisible(true) }}>
                                <Icon type="edit" />
                            </Link>
                            <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluir(item.id)}>
                                <Icon type="delete" />
                            </Link>
                        </div>
                    }
                })

                setOutros(lista);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    }

    const excluir = (outroId) => {
        confirm({
            title: "Pretende excluir este registo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/user-detalhe/excluir-outro",
                    params: {
                        outroId
                    }
                })
                    .then(response => {
                        carregar();
                    })
                    .catch(error => {

                    });
            }
        });
    }

    useEffect(() => {
        carregar();
    }, [])

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Table
                className="tabela-documentos"
                columns={cols}
                pagination={false}
                dataSource={outros}
                loading={{
                    spinning: loading,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
            />
            <div className="opcoes-meus-cursos">
                <Link to="#" className="btn-adicionar" title="Adicionar" onClick={() => { setVisible(true); setOutroId(); }}>
                    +
                </Link>
            </div>
            <DrawerOutros
                outroId={outroId}
                visible={visible}
                extensions={extensions}
                onClose={() => setVisible(false)}
                atualizar={() => { carregar(); setVisible(false); }}
            />
            <ModalViewer
                visible={modalVisible}
                docs={docs}
                onCancel={() => setModalVisible(false)}
            />
        </>
    );
}

export default withRouter(Tabela);